import hsUpload from './upload/index'
// import hsText from './text/index'
import Vue from 'vue'
const components = [hsUpload]

const install = function(Vue) {
  if (install.installed) return
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}
const vue = (typeof window !== 'undefined' && window.Vue) || Vue
if (vue) {
  install(vue)
}

export default {
  install,
  hsUpload,
  // hsText
}



// WEBPACK FOOTER //
// ./src/components/index.js